export const CONSTRUCTION_NOTICE_EVENT = 'construction-notice:open';
export const CONSTRUCTION_THREAD_EVENT = 'construction-notice:thread';
export const CONSTRUCTION_THREAD_OPEN_EVENT = 'construction-notice:thread-open';

export type ConstructionNoticePayload = {
  text?: string;
  source?: string;
};

export type ConstructionThreadDetail = {
  prompt?: string;
  response: string;
  source?: string;
};

const CONSTRUCTION_RESPONSE = `thanks for your message! prest0's ai agent is in active construction. we're targeting a may 2026 launch with a small early access group. you're lucky to see this in stealth—please keep it confidential until we go public.`;

export function openConstructionNotice(payload?: ConstructionNoticePayload): void {
  if (typeof window === 'undefined') return;

  const detail: ConstructionNoticePayload = {
    ...payload,
  };

  window.dispatchEvent(new CustomEvent(CONSTRUCTION_NOTICE_EVENT, { detail }));

  try {
    const threadDetail: ConstructionThreadDetail = {
      prompt: payload?.text,
      response: CONSTRUCTION_RESPONSE,
      source: payload?.source,
    };
    window.dispatchEvent(new CustomEvent(CONSTRUCTION_THREAD_EVENT, { detail: threadDetail }));
    window.dispatchEvent(new Event(CONSTRUCTION_THREAD_OPEN_EVENT));
  } catch {}
}

